import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Listar from '../../../../components/auth/veiculos/listar'


function ListarVeiculosScreen() {

    return (
        <Fragment>
            <Head titulo="Listagem de Veículos da Frota Municipal" />
            <HeaderLogged />
            <Container>
               <Listar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListarVeiculosScreen;